module.exports = __webpack_public_path__ + "img/x-small-gray.63080ffe.svg";